let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9BnO7")).then(() => parcelRequire('dk4Fo'));